import { render, staticRenderFns } from "./payRequest.vue?vue&type=template&id=12a89e74"
import script from "./payRequest.vue?vue&type=script&lang=js"
export * from "./payRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports